export default class {
    _id;
    _uid;
    _createdOn;
    _client;
    _courier;
    _postCode;
    _region;
    _account;
    _postIndex;
    _postPackageGroup;
    _mailsCount;
    _performedMailsCount;
    _tryPerformedMailsCount;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get uid() {
        return this._uid;
    }

    set uid(value) {
        this._uid = value;
    }

    get createdOn() {
        return this._createdOn;
    }

    set createdOn(value) {
        this._createdOn = value;
    }

    get client() {
        return this._client;
    }

    set client(value) {
        this._client = value;
    }

    get courier() {
        return this._courier;
    }

    set courier(value) {
        this._courier = value;
    }

    get postCode() {
        return this._postCode;
    }

    set postCode(value) {
        this._postCode = value;
    }

    get region() {
        return this._region;
    }

    set region(value) {
        this._region = value;
    }

    get account() {
        return this._account;
    }

    set account(value) {
        this._account = value;
    }

    get postIndex() {
        return this._postIndex;
    }

    set postIndex(value) {
        this._postIndex = value;
    }

    set postPackageGroup(value) {
        return this._postPackageGroup = value
    }

    get postPackageGroup() {
        return this._postPackageGroup
    }

    get mailsCount() {
        return this._mailsCount;
    }

    set mailsCount(value) {
        this._mailsCount = value;
    }

    get performedMailsCount() {
        return this._performedMailsCount
    }

    set performedMailsCount(value) {
        this._performedMailsCount = value
    }

    get tryPerformedMailsCount() {
        return this._tryPerformedMailsCount;
    }

    set tryPerformedMailsCount(value) {
        this._tryPerformedMailsCount = value
    }


    // computed properties
    get hasPostPackageGroup() {
        return this._postPackageGroup !== null
    }

    get notPerformedCount() {
        return this._mailsCount - this._performedMailsCount
    }
}